// middleware
import { salesCheckinConfiguration } from '../activities/sales-checkin-dashboard';
import { navigationMiddleware } from '../middleware/navigationMiddleware';
import { postBootstrapMiddleware } from '../middleware/postBootstrapMiddleware';
import { workflowEvaluatorMiddleware } from '../middleware/workflowEvaluatorMiddleware';
import { documentTitleMiddleware } from '../middleware/documentTitleMiddleware';
import { toggleStatsMiddleware } from '../middleware/toggleStatsMiddleware';
import { changeVehicleConfiguration } from '../activities/change-vehicle';
import { tradeInConfiguration } from '../activities/trade-in';
import { creditAppConfiguration } from '../activities/credit-app';
import { dealershipPickerConfiguration } from '../activities/dealership-picker';
import { roleAssumptionConfiguration } from '../activities/role-assumption';
import { showroomNavMiddleware, loaderMiddleware, paymentGridsMiddleware } from '@makemydeal/dr-sales-checkin-store';
import { vehicleDetailsConfiguration } from '../activities/vehicle-details';
import { customerVehiclesMiddleware } from '../activities/customerVehicles/config';
import { customerVehiclesMiddleware as customerVehiclesAppMiddleware } from '../activities/customerVehicles/middleware';
import { webSocketMiddleware } from '../middleware/webSocketMiddleware';
import { dealRefreshModalMiddleware } from '../middleware/dealRefreshModalMiddleware';
import { dealVersionSyncMiddleware } from '../middleware/dealVersionSyncMiddleware';
import { customerCardConfiguration } from '../activities/customer-card';
import { ddjConfiguration } from '../activities/ddj';
import { requestProposalConfiguration } from '../activities/request-proposal';
import { salesCheckinLoaderConfig } from './loaderConfig';
import { newRelicSessionAttributesMiddleware } from '../middleware/newRelicSessionAttributesMiddleware';
import { newRelicJourneyMiddleware } from '../middleware/newRelicJourneyMiddleware';
import { dealSummaryPdfTimingMiddleware } from '../middleware/dealSummaryPdfTimingMiddleware';

export const getRemainingMiddleware = () => {
    return [
        newRelicSessionAttributesMiddleware,
        newRelicJourneyMiddleware,
        postBootstrapMiddleware,
        workflowEvaluatorMiddleware,
        documentTitleMiddleware,
        navigationMiddleware,
        toggleStatsMiddleware,
        salesCheckinConfiguration.middleware,
        showroomNavMiddleware,
        loaderMiddleware(salesCheckinLoaderConfig),
        tradeInConfiguration.middleware,
        creditAppConfiguration.middleware,
        dealershipPickerConfiguration.middleware,
        changeVehicleConfiguration.middleware,
        roleAssumptionConfiguration.middleware,
        vehicleDetailsConfiguration.middleware,
        customerVehiclesMiddleware.middleware,
        customerVehiclesAppMiddleware,
        dealVersionSyncMiddleware,
        customerCardConfiguration.middleware,
        ddjConfiguration.middleware,
        requestProposalConfiguration.middleware,
        customerCardConfiguration.activityMiddleware,
        webSocketMiddleware,
        dealRefreshModalMiddleware,
        paymentGridsMiddleware,
        dealSummaryPdfTimingMiddleware
    ];
};
